type DividerProps = {
  className?: string;
};

export const Divider = ({ className }: DividerProps) => (
  <div className={`my-4 border-t border-special-outline-divider ${className}`} />
);
